'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupId = undefined;
exports.getPopupTypeElement = getPopupTypeElement;
exports.getPopupTypeCustomStylesId = getPopupTypeCustomStylesId;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('./../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupId = exports.PopupId = {
  AppleLoginError: 'appLogErr',
  AppleLoginUnavailable: 'appLogUnav',
  CreateAccountError: 'crAcEr',
  CreatePasswordAndLinkToProfileError: 'crFbPwdEr',
  CreatePasswordAndLinkToProfileErrorAccountExists: 'crFbPwdErAE',
  CreatePasswordAndLinkToProfileSuccess: 'crFbPwdScs',
  FacebookInvalidRequest: 'fbInRq',
  InvalidCredentials: 'inCre',
  InvalidResetPassword: 'inPassRst',
  NoFacebookAccountLinked: 'noFbAc',
  NoEmailOnFacebookAccount: 'noEmFbAc',
  GoogleLoginError: 'gooLogErr',
  GoogleLoginUnavailable: 'gooLogUnav',
  TvCodeExpiryPopup: 'tvCoExPo',
  UnknownError: 'unErr'
};

function getPopupTypeElement(type) {
  switch (type) {
    case PopupId.AppleLoginError:
      return _react2.default.createElement(_components.AppleLoginError, null);
    case PopupId.AppleLoginUnavailable:
      return _react2.default.createElement(_components.AppleLoginUnavailable, null);
    case PopupId.CreateAccountError:
      return _react2.default.createElement(_components.CreateAccountError, null);
    case PopupId.CreatePasswordAndLinkToProfileError:
      return _react2.default.createElement(_components.CreatePasswordAndLinkToProfileError, null);
    case PopupId.CreatePasswordAndLinkToProfileSuccess:
      return _react2.default.createElement(_components.CreatePasswordAndLinkToProfileSuccess, null);
    case PopupId.FacebookInvalidRequest:
      return _react2.default.createElement(_components.FacebookInvalidRequest, null);
    case PopupId.NoFacebookAccountLinked:
      return _react2.default.createElement(_components.NoFacebookAccountLinked, null);
    case PopupId.NoEmailOnFacebookAccount:
      return _react2.default.createElement(_components.NoEmailOnFacebookAccount, null);
    case PopupId.InvalidCredentials:
      return _react2.default.createElement(_components.InvalidCredentials, null);
    case PopupId.InvalidResetPassword:
      return _react2.default.createElement(_components.InvalidResetPassword, null);
    case PopupId.GoogleLoginError:
      return _react2.default.createElement(_components.GoogleLoginError, null);
    case PopupId.GoogleLoginUnavailable:
      return _react2.default.createElement(_components.GoogleLoginUnavailable, null);
    case PopupId.TvCodeExpiryPopup:
      return _react2.default.createElement(_components.TvCodeExpiryPopup, null);
    case PopupId.UnknownError:
      return _react2.default.createElement(_components.UnknownError, null);
    case PopupId.CreatePasswordAndLinkToProfileErrorAccountExists:
      return _react2.default.createElement(_components.CreatePasswordAndLinkToProfileErrorAccountExists, null);
    default:
      return null;
  }
}

function getPopupTypeCustomStylesId(type) {
  switch (type) {
    case PopupId.TvCodeExpiryPopup:
      return "expiry-popup";
    default:
      return "";
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/PopupType.js
// module id = 47
// module chunks = 0